import { Async } from "@lexriver/async"
import { ObservableLocalStorageVariable, ObservableVariable } from "@lexriver/observable"
import { TypeEvent, TypeEventResult } from "@lexriver/type-event"
import { Settings } from "../Settings"
import { EnumUserType } from "./enums/EnumUserType"
import { JsonUser } from "./json-data-types/JsonUser"
import { RequestMaker } from "./server-queries/RequestMaker"
import { ServerUsers } from "./server-queries/ServerUsers"

const filename = 'GlobalUser'

export module GlobalUser{
    let isInitialized = false
    export const eventUserLoggedIn = new TypeEvent<(user:Partial<JsonUser>)=>TypeEventResult>()
    export const eventUserLoggedOut = new TypeEvent<()=>TypeEventResult>()

    export const sessionIdO = new ObservableLocalStorageVariable<string>({
        localStorageKey: Settings.localStorageKey_SessionId
    })

    export const loggedInUserO = new ObservableVariable<Partial<JsonUser>|undefined>(undefined)

    async function assignLoggedInUserOBySessionIdAsync(){
        console.log('assignLoggedInUserOBySessionIdAsync')
        if(!sessionIdO.get()){
            // we do not have sessionId now
            loggedInUserO.set(undefined)
            RequestMaker.initWebsocket()
            return
        }

        // reconnect to websocket with new sessionId
        //RequestMaker.disconnectWebsocket()
        RequestMaker.initWebsocket(sessionIdO.get())

        let result = await ServerUsers.getCurrentJsonUserAsync()
        if(result){
            loggedInUserO.set(result)
        }
    }

    async function initAsync(){
        // console.log('GlobalUser initAsync')
        await assignLoggedInUserOBySessionIdAsync()

        //#region change loggedInUserO if sessionIdO changed
        sessionIdO.eventOnChange.subscribe(async () => {
            await assignLoggedInUserOBySessionIdAsync()
        })
        //#endregion

        //#region trigger events eventUserLoggedIn, eventUserloggedOut
        loggedInUserO.eventOnChange.subscribe(async (newUser?:Partial<JsonUser>, oldUser?:Partial<JsonUser>) => {
            //console.log('loggedInuser eventOnChange TODO:')
            if(newUser?.email == oldUser?.email){
                // same user, skip
                return
            }
            if(newUser){
                await eventUserLoggedIn.triggerAsync(newUser)
                if(!newUser.email) {
                    console.error(filename, 'no email for user', newUser)
                    return
                }
            } else {
                await eventUserLoggedOut.triggerAsync()
            }
        })
        //#endregion

        isInitialized = true
    
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    initAsync()

    async function waitForInitializationAsync(){
        await Async.waitForFunctionToReturnTrueAsync(() => isInitialized, 200, 30*1000)
    }

    export async function checkIfLoggedInAsync():Promise<boolean>{
        await waitForInitializationAsync()
        return loggedInUserO.get() !== undefined
    }

    export async function checkIfAnonymousAsync():Promise<boolean>{
        await waitForInitializationAsync()
        return !(await checkIfLoggedInAsync())
    }

    /**
     * returns logged in user userType or Anonymous instead
     */
    export async function getUserTypeAsync():Promise<EnumUserType>{
        await waitForInitializationAsync()
        const user = loggedInUserO.get()
        if(user) return user.userType ?? EnumUserType.RetailUser

        return EnumUserType.Anonymous
    }


    export async function checkIfCanSeeWholesalePricesAsync():Promise<boolean>{
        await waitForInitializationAsync()
        //return checkIfLoggedIn() && (checkIfWholesaleUser() || checkIfAdmin() || checkIfSPUser())
        const userType = await getUserTypeAsync()
        return await checkIfLoggedInAsync() && [EnumUserType.Administrator, EnumUserType.SP, EnumUserType.WholesaleUser].indexOf(userType)>=0
    }

    export async function checkIfAdminAsync():Promise<boolean>{
        await waitForInitializationAsync()
        const userType = await getUserTypeAsync()
        return await checkIfLoggedInAsync() && [EnumUserType.Administrator].indexOf(userType)>=0
    }

    export async function checkIfSMMAsync():Promise<boolean>{
        await waitForInitializationAsync()
        const userType = await getUserTypeAsync()
        return await checkIfLoggedInAsync() && [EnumUserType.SMM].indexOf(userType)>=0
    }



}